import { render } from "./CameraSwitcher.vue?vue&type=template&id=b7e68246"
import script from "./CameraSwitcher.vue?vue&type=script&lang=ts"
export * from "./CameraSwitcher.vue?vue&type=script&lang=ts"

import "./CameraSwitcher.vue?vue&type=style&index=0&id=b7e68246&lang=scss"
script.render = render

export default script